<template>
    <div>
        <b-card no-body>
            <b-tabs card>
                <b-tab title="RECEIVING" @click="fetch('incoming')">
                    <div style="" v-if="locsubs.length == 0">
                        <loading 
                        :active="true" 
                        :can-cancel="false" 
                        :is-full-page="false">
                        </loading>
                    </div>

                    <div v-else>

                        <b-form-select :options="locsubs" v-model="locsub" @change="get_dates">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- Please pick a location --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                    <b-container style="text-align: left; margin-left: auto; margin-right: auto; margin-top: 10px; max-width: 1600px;">
                        <b-row style="min-height: 500px; height: 100%;" >
                            <b-col style="border: 1px solid gray; padding: 0px; overflow-y: scroll; overflow-x: hidden; font-size: 13px;" cols="1">
                                


                                    <div v-if="dates_being_loaded && locsub != null">

                                        <loading 
                                        :active="true" 
                                        :can-cancel="false" 
                                        :is-full-page="false">
                                        </loading>
                                    </div>

                                    <div v-else>
                                        <div v-if="dates.length == 0">
                                            <b-alert show>NO DATES</b-alert>
                                        </div>
                                        <div v-else>
                                            <button size="sm" v-for="date,didx in dates" v-bind:key="didx" variant="secondary" href="#" :disabled="active_date ==  date.date"
                                        @click="get_items_for_date(date)" style="margin-bottom: 3px; display: block; width: 100%;">{{date.date}} ({{date.nitems}})</button>
                                        </div>
                                    </div>

                            </b-col>

                            <b-col fluid style="border: 1px solid gray; padding: 10px; overflow-y: scroll; max-height: 900px;">
                                <div style="width: 100%; height: 100%;" v-if="items_being_loaded==true">
                                    <loading 
                                    :active="true" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                    </loading>
                                </div>

                                <div v-else>
                                    <div v-if="items.length > 0" style="position: relative;">
                                        <div v-for="loc, lidx in items" v-bind:key="lidx" style="margin-bottom: 5px;">
                                            <h4>{{packet.locsubsdict[loc.locsub]}}</h4>
                                            <table style="width: 100%;">
                                                <thead>
                                                    <tr style="background: #efefef;">
                                                        <td class="ipt_tdhr" style="width: 140px;">
                                                            INVOICE #
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            ITEM
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            QTY
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            TYPE
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            FROM
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            CURRENT STATUS
                                                        </td>


                                                        <td class="ipt_tdhr">
                                                            NEW STATUS
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            COMMENTS
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            ACTION
                                                        </td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="item,idx in loc.items" v-bind:key="idx">
                                                        <td class="ipt_tdr">
                                                            {{ item.invoice_id }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <div>{{ item.product_name }} (<b>{{item.product_sku}}</b>)</div>
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ item.quantity }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ (item.order_type || '').toUpperCase() }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ packet.locsubsdict[item.locsub] }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ states_incoming_current_dict[item.state] }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <b-form-select 
                                                            :options="states_incoming_new" v-model="item.new_state">

                                                            </b-form-select>
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <span v-if="comments_dict[item.invoice_id+'|'+item.itemid]">

                                                                <button style="border: 1px solid black; color: red; font-weight: bold;" @click="show_comments(item)">CMNT ({{ comments_dict[item.invoice_id+'|'+item.itemid]}})
                                                                </button>
                                                            </span>

                                                            <span v-else>
                                                                 <button  @click="show_comments(item)">CMNT
                                                                </button>
                                                            </span>
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <button @click="update_invoice_item_state(item)">SAVE</button>
                                                        </td>

                                                    </tr>
                                                </tbody>


                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-col>


                        </b-row>
                    </b-container>
                </b-tab>

                <b-tab title="SHIPPING" @click="fetch('outgoing')">
                    <div style="" v-if="locsubs.length == 0">
                        <loading 
                        :active="true" 
                        :can-cancel="false" 
                        :is-full-page="false">
                        </loading>
                    </div>

                    <div v-else>
                        <b-form-select :options="locsubs" v-model="locsub" @change="get_dates">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- Please pick a location --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                    <b-container style="text-align: left; margin-left: auto; margin-right: auto; margin-top: 10px; max-width: 1600px;">
                        <b-row style="min-height: 500px; height: 100%;" >
                            <b-col style="border: 1px solid gray; padding: 0px; overflow-y: scroll; overflow-x: hidden; font-size: 13px;" cols="1">
                                    <div v-if="dates_being_loaded && locsub != null">

                                        <loading 
                                        :active="true" 
                                        :can-cancel="false" 
                                        :is-full-page="false">
                                        </loading>
                                    </div>

                                    <div v-else>
                                        <div v-if="dates.length == 0">
                                            <b-alert show>NO DATES</b-alert>
                                        </div>
                                        <div v-else>
                                            <button size="sm" v-for="date,didx in dates" v-bind:key="didx" variant="secondary" href="#" :disabled="active_date ==  date.date"
                                        @click="get_items_for_date(date)" style="margin-bottom: 3px; display: block; width: 100%;">{{date.date}} ({{date.nitems}})</button>
                                        </div>
                                    </div>
                            </b-col>

                            <b-col fluid style="border: 1px solid gray; padding: 10px; overflow-y: scroll; max-height: 900px;">
                                <div style="width: 100%; height: 100%;" v-if="items_being_loaded==true">
                                    <loading 
                                    :active="true" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                    </loading>
                                </div>

                                <div v-else>
                                    <div v-if="items.length > 0" style="position: relative;">
                                        <div v-for="loc, lidx in items" v-bind:key="lidx" style="margin-bottom: 5px;">
                                            <h4>{{packet.locsubsdict[loc.locsub]}}</h4>
                                        
                                            <table style="width: 100%;">
                                                <thead>
                                                    <tr style="background: #efefef;">
                                                        <td class="ipt_tdhr" style="width: 150px;">
                                                            INVOICE #
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            ITEM
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            QTY
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            TYPE
                                                        </td>


                                                        <td class="ipt_tdhr">
                                                            OUTGOING TYPE
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            CURRENT STATUS
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            NEW STATUS
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            COMMENTS
                                                        </td>

                                                        <td class="ipt_tdhr">
                                                            ACTION
                                                        </td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="item,idx in loc.items" v-bind:key="idx">
                                                        <td class="ipt_tdr">
                                                            {{ item.invoice_id }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <div>{{ item.product_name }} (<b>{{item.product_sku}}</b>)</div>
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ item.quantity }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ (item.order_type || '').toUpperCase() }}
                                                        </td>

                                                        <td class="ipt_tdr" style="padding: 0px;">
                                                            <div v-if="item.outgoing_type == 'load'">
                                                                <b-alert show variant="primary"
                                                                style="margin: 0px;">LOAD</b-alert>
                                                            </div>
                                                            <div v-else-if="item.outgoing_type == 'pickup'">
                                                                <b-alert show variant="warning"
                                                                style="margin: 0px;">PICKUP</b-alert>
                                                            </div>
                                                            <div v-else>
                                                                N/A
                                                            </div>
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            {{ states_outgoing_current_dict[item.state] }}
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <b-form-select 
                                                            :options="states_outgoing_new" v-model="item.new_state">

                                                            </b-form-select>
                                                        </td>

                                                        <td class="ipt_tdr">

                                                            <span v-if="comments_dict[item.invoice_id+'|'+item.itemid]">

                                                                <button style="border: 1px solid black; color: red; font-weight: bold;" @click="show_comments(item)">CMNT ({{ comments_dict[item.invoice_id+'|'+item.itemid]}})
                                                                </button>
                                                            </span>

                                                            <span v-else>
                                                                 <button  @click="show_comments(item)">CMNT
                                                                </button>
                                                            </span>
                                                        </td>

                                                        <td class="ipt_tdr">
                                                            <button @click="update_invoice_item_state(item)">SAVE</button>
                                                        </td>

                                                    </tr>
                                                </tbody>


                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-col>


                        </b-row>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-card>

        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "IncomingOutgoing",
        components: {flatPickr, Loading, ItemComments},
        data: function(){
            let out = {
                items: [],
                dates: [],
                active_date:null,
                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                type: 'incoming',
                locsubs: [],
                locsub: null,
                states_incoming_current: mappings.states,
                states_incoming_new: mappings.states.filter(function(d){
                    return [4,-4].includes(d.value) 
                }),
                states_outgoing_current: mappings.states,
                states_outgoing_new: mappings.states,         
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
            }

            out.states_incoming_current_dict = Object.assign({}, ...out.states_incoming_current.map((x) => ({[parseInt(x.value)]: x.text}))
            );

            out.states_outgoing_current_dict = Object.assign({}, ...out.states_outgoing_current.map((x) => ({[parseInt(x.value)]: x.text}))
            );
            return out;

        },
        methods: {
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-comments");
            },
            update_invoice_item_state: function(item){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;
                
                let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: item.new_state, changed_by: this.packet.userDetails.username}

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            get_dates: function(){
                let path = ""
                let that = this;
                if (this.type == 'incoming'){
                    path = "/api/sales/get_incoming_items_dates/"
                }
                else if(this.type == 'outgoing') {
                    path = "/api/sales/get_outgoing_items_dates/"
                }
                
                if (!path){
                    return
                } 
                let data = {locsub: this.locsub}

                let s = function(response) {
                    if (response.data.result){

                        that.dates = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error retrieving dates for the incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }
                this.items = [];
                this.dates_being_loaded = true;
                this.active_date = null;
                Requestor.getSync(path, data, s, f);
            },
            get_items_for_date: function(date){
                this.active_date = date.date;
                
                let that = this;
                let path = ""
                if (this.type == 'incoming'){
                    path = "/api/sales/get_incoming_items/"
                }
                else {
                    path = "/api/sales/get_outgoing_items/"
                }

                if (!path){
                    return
                }
                let data = {locsub: this.locsub, date: date.date}
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                    that.items_being_loaded = false;
                    that.get_batch_comments();
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching items for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.items_being_loaded = true;
                Requestor.getSync(path, data, s, f);
            },
            get_batch_comments: function(){
                // let items = this.items.map(function(d){
                //     return {invoice_id: d.invoice_id, itemid: d.itemid}
                // })

                let items = [];
                for (var i =0; i<this.items.length; i++){
                    for (var j=0; j<this.items[i].items.length; j++){
                        items.push(
                            {
                                invoice_id: this.items[i].items[j].invoice_id,
                                itemid: this.items[i].items[j].itemid,
                            }
                        )
                    }
                }
                let path = "/api/sales/get_batch_comments/"
                let data = {items: items};
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        //that.items = response.data.result;
                        //console.log(response.data.result);
                        let comments = response.data.result;
                        if (comments.length > 0){
                            that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                            console.log(that.comments_dict);
                        }
                        
                    }
                    else {
                        console.log(response.data.error)
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                
                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading comments.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsync(path, data, s, f);
            },
            fetch_prereqs: function(){
            },
            fetch: function(type){
                
                this.type = type;
                this.items = []
                this.dates = []
                this.active_date = null;
                //this.locations = [];
                this.locsub = null;
                //this.get_dates()
            },


        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            let that = this;
            this.locsubs = this.packet.locsubs.filter(function(d){
                // if(that.packet.userDetails.userrole == "admin" || that.packet.userDetails.userrole == "warehouseuser" || that.packet.userDetails.userrole == "warehousemanager" ){
                //     return d
                // }
                // else {
                //     return that.packet.userDetails.properties.location_id == parseInt(d.value.split("|")[0]);
                // }


                if (that.packet.userDetails.properties.location_id != null){
                    return
                        ( 
                        (that.packet.userDetails.properties.location_id == parseInt(d.value.split("|")[0]))
                        ||
                        d.is_main_warehouse == true
                        )
                }
                else {
                    if (that.packet.userDetails.userrole == "admin"){
                        return d
                    }
                    else {
                        return d.is_main_warehouse == true
                    }
                }

            });


            if (this.packet.userDetails.userrole == "admin"){
                this.locsubs.splice(0, 0, {value: 'all', text: 'ALL'});

            }
            //this.locations = this.packet.locations.filter(function(d){return d.text != "All"});

            
            
        }

    }

</script>

<style scoped>
    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/IncomingOutgoing.vue